export default __webpack_public_path__ + "04eb90eda5f392d34833f1ae32f76511.png";